import {createFileRoute} from '@tanstack/react-router';

import WorkList from '@/practitioner/views/diagnosticReport/WorkList';

export const Route = createFileRoute('/(practitioner)/practitioner/work-list')({
  component: WorkList
});
